import type { MyWorkstreamInterface } from '@/api-client/pipeline/my-workstreams';
import type { MenuSubItemInterface } from '../types';

export function workstreamNavLink(workstream: MyWorkstreamInterface): string {
  return workstream.kind === 'project'
    ? `/project/${workstream.id}`
    : `/pipeline/${workstream.id}`;
}

export function mapMyWorkstreamsToSubItems(
  workstreams: MyWorkstreamInterface[]
): MenuSubItemInterface[] {
  return workstreams.map((workstream) => ({
    title: workstream.name,
    link: workstreamNavLink(workstream)
  }));
}
